const routes = [
  {
    path: '/nodes',
    name: 'nodes',
    redirect: { name: 'clusters' },
    component: () =>
      import(/* webpackChunkName: 'nodes' */ '@/views/nodes/NodesMain.vue'),

    children: [
      {
        path: 'single',
        name: 'nodes-single',
        component: () =>
          import(/* webpackChunkName: 'nodes' */ '@/views/nodes/Nodes.vue')
      },

      {
        path: 'single/new/:planId?',
        name: 'nodes-new',
        component: () =>
          import(
            /* webpackChunkName: 'nodes-new' */ '@/views/nodes/CreateNode.vue'
          )
      },
      {
        path: 'single/renew/:planId',
        name: 'nodes-renew',
        component: () =>
          import(
            /* webpackChunkName: 'nodes-renew' */ '@/views/nodes/NodesRenew.vue'
          )
      },

      {
        path: 'clusters',
        name: 'clusters',
        component: () =>
          import(
            /* webpackChunkName: 'clusters' */ '@/views/nodes/Clusters.vue'
          )
      },
      {
        path: 'clusters/new/:planId?',
        name: 'clusters-new',
        component: () =>
          import(
            /* webpackChunkName: 'clusters-new' */ '@/views/nodes/CreateCluster.vue'
          )
      },
      {
        path: 'clusters/renew/:planId',
        name: 'clusters-renew',
        component: () =>
          import(
            /* webpackChunkName: 'clusters-renew' */ '@/views/nodes/ClusterRenew.vue'
          )
      }
    ]
  }
]

export default routes
